import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import Fade from "react-reveal";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Breadcrumb, BreadcrumbItem, Form, FormGroup } from "reactstrap";

// API
import { SPECIALITY_DETAILS } from "services/ApiCalls";
import { catchAsync, checkResponse } from "utilities/utilities";

const SpecialityDetails = () => {
  const [data, setData] = useState();
  const { id } = useParams();
  const navigate = useNavigate();

  const getData = catchAsync(async () => {
    const res = await SPECIALITY_DETAILS(id);
    checkResponse({
      res,
      setData: (data) => {
        setData(data);
      },
    });
  });

  useEffect(() => {
    if (id) getData();
  }, [id]);

  return (
    <Fade>
      <section className="addresources comon_dashpad">
        <Form>
          <div className="comom_fillter_set text-start">
            <div className="resource_headwrap d-flex align-items-center justify-content-between">
              <h5 className="fillter_head">View Speciality Details</h5>
            </div>

            {/* Breadcrumb */}
            <div className="breadcrumb_set mt-3">
              <Breadcrumb>
                <BreadcrumbItem onClick={() => navigate(-1)}>
                  <Link to="#">Manage Speciality</Link>
                </BreadcrumbItem>
                <BreadcrumbItem active>View Details</BreadcrumbItem>
              </Breadcrumb>
            </div>

            {/* Details Section */}
            <div className="addresources_bottom_form rounded-3 p-3">
              <div className="author_form mt-5">
                <Row>
                  <h5 className="text-white">Name</h5>
                  <Col lg={6} md={6} sm={12}>
                    <FormGroup className="position-relative flex_fields">
                      <p className="text_line">{data?.name}</p>
                    </FormGroup>
                  </Col>
                </Row>

                {/* If you want to show icon */}
                {data?.icon && (
                  <Row className="mt-4">
                    <h5 className="text-white">Icon</h5>
                    <Col lg={6} md={6} sm={12}>
                      <img
                        src={data?.icon}
                        alt="Speciality Icon"
                        style={{
                          maxWidth: "120px",
                          borderRadius: "8px",
                          background: "#222",
                          padding: "5px",
                        }}
                      />
                    </Col>
                  </Row>
                )}
              </div>
            </div>
          </div>
        </Form>
      </section>
    </Fade>
  );
};

export default SpecialityDetails;
